module.exports = __webpack_public_path__ + "static/us-enterprise-work-better-c2e7a436d084844f23c5b7514853f369.gif";